import Upload from './components/upload'
import Vue from 'vue'
Upload.install = () => {
  Vue.component(Upload.name, Upload)
}

export default Upload



// WEBPACK FOOTER //
// ./packages/upload/components/upload/index.js